import {
  FileText,
  ShieldCheck,
  CreditCard,
  Truck,
  AlertTriangle,
  Scale,
  Copyright,
  Mail,
} from "lucide-react";
import SiteFooter from "@/components/SiteFooter";

const sections = [
  {
    icon: FileText,
    title: "1. Acceptance of Terms",
    content:
      "By accessing this website or using the services of Printzee Media and Advertising Solutions FZE, you agree to be bound by these Terms & Conditions. If you do not agree with these terms, please discontinue use of our website and services.",
  },
  {
    icon: ShieldCheck,
    title: "2. Our Services",
    content:
      "Printzee Media and Advertising Solutions FZE provides branding, printing, signage, exhibition displays, promotional materials, corporate gifts, event branding, installation, and related advertising solutions. All services are subject to availability, written quotations, and order confirmation.",
  },
  {
    icon: CreditCard,
    title: "3. Quotations & Payments",
    content:
      "All quotations are based on the information provided by the client and remain valid for the period specified in the quotation. Production may begin only after quotation approval, artwork confirmation, and payment in accordance with the agreed payment terms.",
  },
  {
    icon: FileText,
    title: "4. Order Confirmation",
    content:
      "Orders are considered confirmed only after receiving written approval from the client and any required advance payment. Any requested modifications after confirmation may result in revised pricing and production timelines.",
  },
  {
    icon: AlertTriangle,
    title: "5. Artwork Approval",
    content:
      "Clients are responsible for carefully reviewing and approving all artwork, designs, dimensions, colors, spelling, logos, and specifications before production. Printzee Media and Advertising Solutions FZE is not responsible for errors that have been approved by the client.",
  },
  {
    icon: Truck,
    title: "6. Production & Delivery",
    content:
      "Estimated production and delivery schedules are provided in good faith but are not guaranteed. Delays caused by material availability, client approval, shipping providers, force majeure events, or circumstances beyond our reasonable control shall not constitute a breach of contract.",
  },
  {
    icon: ShieldCheck,
    title: "7. Product Quality",
    content:
      "Minor variations in color, dimensions, finishing, print positioning, or material texture may occur due to printing processes, manufacturing tolerances, lighting conditions, and screen calibration differences. Such variations are considered acceptable within industry standards.",
  },
  {
    icon: Copyright,
    title: "8. Intellectual Property",
    content:
      "All website content, graphics, branding, text, images, logos, layouts, and designs remain the intellectual property of Printzee Media and Advertising Solutions FZE unless otherwise agreed in writing. Unauthorized reproduction or distribution is prohibited.",
  },
  {
    icon: ShieldCheck,
    title: "9. Client Responsibilities",
    content:
      "Clients confirm that they have the necessary rights or permissions to use all logos, trademarks, artwork, text, and other materials submitted for production. The client accepts full responsibility for any infringement resulting from supplied content.",
  },
  {
    icon: AlertTriangle,
    title: "10. Cancellations & Refunds",
    content:
      "Orders cannot be cancelled once production has commenced. Refunds are not available for customized or personalized products except where required by applicable law or where otherwise agreed in writing.",
  },
  {
    icon: Scale,
    title: "11. Limitation of Liability",
    content:
      "To the fullest extent permitted by applicable law, Printzee Media and Advertising Solutions FZE shall not be liable for any indirect, incidental, consequential, or special damages arising from the use of our website, products, or services.",
  },
  {
    icon: Scale,
    title: "12. Governing Law",
    content:
      "These Terms & Conditions shall be governed by and interpreted in accordance with the applicable laws of the United Arab Emirates. Any disputes shall be subject to the exclusive jurisdiction of the competent courts of the UAE.",
  },
  {
    icon: Mail,
    title: "13. Contact Information",
    content:
      "For questions regarding these Terms & Conditions, please contact Printzee Media and Advertising Solutions FZE using the contact information provided on our website.",
  },
];

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 text-white py-24">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <span className="inline-block bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm text-blue-200">
            Legal Information
          </span>

          <h1 className="text-5xl md:text-6xl font-bold mt-6">
            Terms & Conditions
          </h1>

          <p className="max-w-3xl mx-auto mt-6 text-lg text-gray-300 leading-8">
            These Terms & Conditions govern your use of the website and services
            provided by{" "}
            <strong className="text-white">
              Printzee Media and Advertising Solutions FZE
            </strong>
            . By accessing our website or placing an order, you agree to comply
            with these terms.
          </p>

          <p className="mt-8 text-sm text-gray-400">
            Last Updated: July 2026
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-5">
            Welcome
          </h2>

          <p className="text-gray-600 leading-8">
            Thank you for choosing Printzee Media and Advertising Solutions FZE.
            These Terms & Conditions establish the rules governing the use of
            our website and services. We encourage you to read them carefully
            before requesting quotations, placing orders, or engaging our
            services.
          </p>
        </div>
      </section>

      {/* Terms */}
      <section className="max-w-6xl mx-auto px-6 pb-20">
        <div className="grid gap-8">
          {sections.map((section, index) => {
            const Icon = section.icon;

            return (
              <div
                key={index}
                className="bg-white rounded-3xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 p-8"
              >
                <div className="flex gap-5">
                  <div className="h-14 w-14 rounded-xl bg-blue-600 flex items-center justify-center text-white flex-shrink-0">
                    <Icon size={24} />
                  </div>

                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900">
                      {section.title}
                    </h3>

                    <p className="mt-4 text-gray-600 leading-8">
                      {section.content}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

     
            <SiteFooter />
          
    </div>
  );
}